export const getOptionLabel = <T = string>(values: { value: T; label: string }[], searchValue: T): string => {
  return values.find(({ value }) => value === searchValue)?.label ?? '';
};
